import type { ErrorTranslations } from "./utils";

export default {
  signature_verification_failed: {
    EN: "Signature verification failed",
    RO: "Verificarea semnăturii a eșuat",
  },
  responsible_not_found: {
    EN: "Responsible person not found",
    RO: "Responsabilul nu a fost găsit",
  },
  not_found: {
    EN: "Document not found",
    RO: "Documentul nu a fost găsit",
  },
  form_not_found: {
    EN: "Form not found",
    RO: "Formularul nu a fost găsit",
  },
  department_not_found: {
    EN: "Department not found",
    RO: "Departamentul nu a fost găsit",
  },
  document_already_signed: {
    EN: "Document already signed",
    RO: "Documentul a fost deja semnat",
  },
} satisfies ErrorTranslations;
